import React, { useContext } from "react"

import { Color } from "~tailwindui/types/enums"

import TutorContext from "~Tutor/TutorContext"
import { path } from "~Tutor/TutorRoutes"
import { H2, StyledLink } from "~tailwindui/Basics"

import ApprovedExpenses from "./ApprovedExpenses"
import ChangesRequestedExpenses from "./ChangesRequestedExpenses"
import DeniedExpenses from "./DeniedExpenses"
import SubmittedExpenses from "./SubmittedExpenses"

const TutorExpensesList = () => {
  const { viewer } = useContext(TutorContext)

  return (
    <>
      <H2>My Expenses</H2>
      {viewer.mayCreateExpense && (
        <div>
          <StyledLink to={path("expenseNew")} button color={Color.Orange}>
            New Expense
          </StyledLink>
        </div>
      )}
      <ChangesRequestedExpenses />
      <SubmittedExpenses />
      <ApprovedExpenses />
      <DeniedExpenses />
    </>
  )
}

export default TutorExpensesList
